import { Link } from "react-router-dom";
import { Calendar } from "lucide-react";
import { displayEventTimeShort } from "@/lib/datetime";

interface NextNimiProps {
  event?: {
    id: string;
    title: string;
    venue: string;
    start_time: string;
  };
}

const NextNimi = ({ event }: NextNimiProps) => {
  const hasEvent = !!event;
  return (
    <Link
      to={event ? `/events/${event.id}` : "/events"}
      className="block bg-card rounded-lg p-4 shadow-md hover:shadow-lg transition-shadow"
    >
      <div className="flex items-center mb-2">
        <Calendar className="text-secondary mr-2" />
        <h2 className="text-lg font-semibold text-card-foreground">Your Next Nimi</h2>
      </div>
      {/* user has booked an event */}
      {hasEvent && (
        <>
          <div className="text-muted-foreground">{event.title}</div>
          <div className="text-sm text-muted-foreground">
            {(() => { const t = displayEventTimeShort(event.start_time); return `${t.date} at ${t.time}`; })()} • {event.venue}
          </div>
        </>
      )}
      
      {/* user hasn't booked any event */}
      {!hasEvent && (
        <div className="text-muted-foreground">
          Great art. Great people. What are you waiting for?
        </div>
      )}
    </Link>
  );
};

export default NextNimi;
